// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"178":"6a34601bd4b717b647b3","488":"039a5d6c038e2e864996","562":"12816a740fb7004cd7a1","812":"246bfa8d291bb093aef6"}[chunkId] + ".chunk.js";
};